<template>
  <div class="row" v-if="canRead">
    <div class="col-md-12">
      <card>
        <tabs v-if="flexmonsterEnabled" ref="filesTabs" value="Files" tab-content-classes="text-center">
          <tab-pane title="Inspection Reports" key="inspectionReports" id="inspection-reports">
            <inspection-reports></inspection-reports>
          </tab-pane>
          <tab-pane title="Flexmonster Reports" key="flexmonsterReports" id="flexmonster-reports">
            <flexmonster-generate-data></flexmonster-generate-data>
          </tab-pane>
        </tabs>
        <inspection-reports v-else></inspection-reports>
      </card>
    </div>
  </div>
</template>

<script>
import FlexmonsterGenerateData from '@/components/Dashboard/Views/Reports/FlexmonsterGenerateData'
import InspectionReports from '@/components/Dashboard/Views/Reports/InspectionReports'
import Permissions from '@/utilities/permissions'
import {Card, TabPane, Tabs} from '@/components/UIComponents'

export default {
  components: {
    Card,
    Tabs,
    TabPane,
    FlexmonsterGenerateData,
    InspectionReports
  },
  computed: {
    canRead() {
      return this.$can('read', Permissions.REPORTS)
    },
    flexmonsterEnabled() {
      return process.env.VUE_APP_FLEXMONSTER_REPORTING_ENABLED === 'true'
    }
  }
}
</script>
